import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import { PrintReceivedPalletAndCaseLabels } from './printReceivedPalletAndCaseTags';

function PrintConsumedPalletAndCaseLabelsModal({ onClose, open, poMapGroupId, poMapId, type }) {
    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
                <DialogTitle style={{ textAlign: 'center', paddingBottom: 0 }}>
                    Print Pallet And Case Labels for Consumed Lots That Have No Units in Jalapeno.
                </DialogTitle>
                <DialogContent style={{ margin: 0 }}>
                    <PrintReceivedPalletAndCaseLabels
                        includeEmptyCases
                        poMapGroupId={poMapGroupId}
                        poMapId={poMapId}
                        type={type}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
}

export { PrintConsumedPalletAndCaseLabelsModal };
